/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react'
import { useState, useContext } from 'react'
import { useEffect } from 'react'
import ErrorMessage from '../../../../components/ErrorMessage'
import Loader from '../../../../components/Loader'
import { passwordCriteria } from './passwordCriteria'
import { userService } from '../../../../services/user.services'
import GlobalContext from '../../../../components/Context/GloablContext'
import BannerImage from '../../../../components/BannerImage'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { dataService } from '../../../../services/data.services'
import { clearAuthSession, broadcastLogout } from '../../../../CommonMethods/authSession';

export default function ForgotResetPassword() {
    const navigate = useNavigate()
    const [type, settype] = useState({
        new_password: false,
        confirm_new_password: false
    })
    const [searchParams] = useSearchParams();  // Get URL parameters
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    const [inputFields, setInputFields] = useState({
        new_password: "",
        confirm_new_password: ""
    })
    const [loading, setLoading] = useState(false)
    const [Overallerror, setOverallerror] = useState({
        "dependant_error1": false,
        "dependant_error2": false,
        "new_pass": '',
        "confirm_new_pass": ''
    })

    const [submitSelected, setSubmitSelected] = useState(false)

    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext)
    const handleShowPassword = (id) => {
        settype((prev) => ({
            ...prev,
            [id]: !type[id]
        }));
    }


    const isPasswordValid = Object.values(passwordCriteria).every((criteria) => {
        return criteria.regex.test(inputFields?.new_password);
    });

    const handleResetPassword = async (e) => {
        e.preventDefault()
        setSubmitSelected(true)
        setLoading(true)

        if (inputFields.new_password.trim() !== inputFields.confirm_new_password.trim()) {
            setOverallerror((prev) => ({ ...prev, dependant_error2: true, dependant_error1: false, confirm_new_pass: 'Passwords do not match', new_pass: '' }))
            setLoading(false)
            return
        }

        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const payload = {
            "token": token,
            "new_password": inputFields.new_password,
            "confirm_password": inputFields.confirm_new_password,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        }
        const endpoint = `patients/forgot-password-verify`
        try {
            const ResetResponse = await userService.forgotPassword(endpoint, payload);
            if (!ResetResponse.error) {
                const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
                setToastmessage("Password reset sucessfull!");
                setLoading(false)
                clearAuthSession();
                broadcastLogout();
                navigate('/')
            }
            else {
                setToastErrorMessage(ResetResponse?.message?.response?.data?.message)
                navigate('/404')
            }
        } catch (err) {

        }
    }

    useEffect(() => {
        setLoading(true);
        const token = searchParams.get("token");  // Extract token from URL
        if (!token) {
            setError("Token not found in URL");
            setLoading(false);
            return;
        }
        const validateToken = async () => {
            try {
                const response = await dataService.PostAPI(
                    { token },
                    "users/validate-token",
                );
                setData(response.data);
            } catch (error) {
                if (error.response?.status === 400) {
                    setToastErrorMessage("Token has expired")
                    setTimeout(() => {
                        navigate("/404");
                        setToastErrorMessage("")
                    }, 3000); 
                }
                setLoading(false);
            }
        };
        validateToken();
        setLoading(false)
    }, []);

    return (
        <div className='flex'>
            <BannerImage />
            <div className='w-[35%] 2xl:w-[30%] pl-[30px] 2xl:pl-0'>
                <div className='w-[280px] xl:[290px] 2xl:w-[320px] flex flex-col justify-center pt-7 pb-5 items-center h-screen overflow-auto scrollBar-hidden'>
                    <div className='w-full'>
                        <img src="/images/Arcm_login_logo.png" alt="Banner-Img" className='w-fit h-fit mx-auto' loading='lazy' decoding='async' />
                        <h1 className='mt-6 text-[36px] font-normal text-[#000] text-center'>Forgot Password</h1>
                        <h1 className='text-lg font-normal text-[#000] text-center'>Regain access and strengthen security with a new password</h1>
                        <form action="" className='mt-8' onSubmit={(e) => handleResetPassword(e)}>
                            <div className='flex flex-col mt-3'>
                                <label htmlFor='new_password' className='text-xs font-semibold text-[#000] pb-1.5'>New Password*</label>
                                <div className='relative'>
                                    <input type={type['new_password'] ? "text" : "password"} id='new_password'
                                        value={inputFields["new_password"]}
                                        onFocus={() => {
                                            setOverallerror((prev) => ({
                                                ...prev,
                                                dependant_error1: false,
                                                dependant_error2: false,
                                                temp_pass: '',
                                                new_pass: '',
                                                confirm_new_pass: ''
                                            }))
                                            setSubmitSelected(false)
                                        }}
                                        style={{ border: `1px solid ${submitSelected && (Overallerror.new_pass !== '' || (Overallerror.dependant_error2 && Overallerror.confirm_new_pass) || Overallerror.dependant_error1) ? '#C81720' : '#C5C9DA'}` }}
                                        onChange={(e) => {
                                            setInputFields((prev) => ({ ...prev, "new_password": (e.target.value).trim() }))
                                        }}
                                        className='border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm 
                                    font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none
                                    focus:border-[#339D9E] focus:shadow-s1'
                                        autoComplete='off' placeholder='Enter new password' />
                                    <button type='button' onClick={() => handleShowPassword('new_password')} className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                        <span className='text-xs font-semibold text-[#008586]'>{type['new_password'] ? "HIDE" : "SHOW"}</span>
                                    </button>
                                </div>
                            </div>
                            {Overallerror.new_pass !== '' && <ErrorMessage error message={Overallerror.new_pass} />}
                            <div className='flex flex-col mt-3'>
                                <label htmlFor='confirm_new_password' className='text-xs font-semibold text-[#000] pb-1.5'>Confirm new Password*</label>
                                <div className='relative'>
                                    <input type={type['confirm_new_password'] ? "text" : "password"} id='confirm_new_password'
                                        value={inputFields["confirm_new_password"]}
                                        onFocus={() => {
                                            setOverallerror((prev) => ({
                                                ...prev,
                                                dependant_error1: false,
                                                dependant_error2: false,
                                                temp_pass: '',
                                                new_pass: '',
                                                confirm_new_pass: ''
                                            }))
                                            setSubmitSelected(false)
                                        }}
                                        style={{ border: `1px solid ${submitSelected && (Overallerror.confirm_new_pass !== '' || (Overallerror.dependant_error2 && Overallerror.confirm_new_pass !== "")) ? '#C81720' : '#C5C9DA'}` }}
                                        onChange={(e) => {
                                            setInputFields((prev) => ({ ...prev, "confirm_new_password": (e.target.value).trim() }))
                                        }}
                                        className='border border-[#C5C9DA] rounded-lg pl-3.5 py-[11px] pr-[60px] text-sm 
                                    font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none
                                    focus:border-[#339D9E] focus:shadow-s1'
                                        autoComplete='off' placeholder='Enter new password' />
                                    <button type='button' onClick={() => handleShowPassword("confirm_new_password")} className='absolute top-1/2 right-3.5 -translate-y-[50%]'>
                                        <span className='text-xs font-semibold text-[#008586]'>{type['confirm_new_password'] ? "HIDE" : "SHOW"}</span>
                                    </button>
                                </div>
                            </div>
                            {Overallerror.confirm_new_pass !== '' && <ErrorMessage error message={Overallerror.confirm_new_pass} />}
                            <div className='mt-4'>
                                <p className='text-sm font-normal text-[#000000] mb-1.5'>Password must have :</p>
                                <ul>
                                    {Object.keys(passwordCriteria).map((criteria, index) => (
                                        <li className={`mb-1.5 flex`} key={criteria}>
                                            <span className='pt-1'>
                                                <img src={(inputFields.new_password === '') ? `/images/password_failed.svg` : (!passwordCriteria[criteria]["regex"].test(inputFields['new_password']) && inputFields.new_password !== '') ? '/images/password_not_satisfied.svg' : "/images/password_satisfied.svg"} alt="icon" />
                                            </span>
                                            {/* text-[#1A883C] */}
                                            <span className={`text-sm font-normal ${(inputFields.new_password.trim() === '') ? 'text-[#000000]' : (!passwordCriteria[criteria]["regex"].test(inputFields['new_password']) && inputFields.new_password.trim() !== '') ? 'text-[#C81720]' : 'text-[#1A883C]'}  pl-1.5`}>
                                                {index === 4 ? <>{criteria.split('\n')[0]}<br />{criteria.split('\n')[1]}</> : criteria}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <button type='submit'
                                id="login"
                                disabled={loading || !isPasswordValid || Object.values(inputFields).some(value => typeof value === 'string' && value.trim() === '')}
                                className={`w-full mt-8 py-2.5 px-2 text-lg font-semibold text-[#fff] rounded-[16px] 
                             ${loading || !isPasswordValid || Object.values(inputFields).some(value => typeof value === 'string' && value.trim() === '') ? 'bg-[#777C88]' : 'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50]'} `}>
                                {!loading ? 'Reset Password' : <span>{<Loader />}</span>}
                            </button>
                            <div className='flex justify-center w-full mt-6'>
                                <button disabled={loading} onClick={() => { navigate('/') }} className='flex items-center'>
                                    <span className='text-lg font-normal text-[#008586] ml-3'>Back to Login</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
